import '../ServiceableUrls.less';
import React from 'react';
import { Table } from 'antd';
import { ServiceableUrl, ServiceableUrlTableRecord } from '../types';
import { getServiceableUrlsTableData } from '../utils';
import ServiceableUrlsSeoScoreCell from './ServiceableUrlsSeoScoreCell';
import ServiceableUrlsChecksCell from './ServiceableUrlsChecksCell';
import ServiceableUrlsLastAnalyzedCell from './ServiceableUrlsLastAnalyzedCell';
import ServiceableUrlsActionCell from './ServiceableUrlsActionCell';
import ServiceableUrlsLinkCell from './ServiceableUrlsLinkCell';
import { UrlCluster } from '../../urlClusters/types';

const { Column } = Table;

type Props = {
    serviceableUrls: ServiceableUrl[];
    urlClusters: UrlCluster[];
    isLoading?: boolean;
    isCheckButtonLoading?: boolean;
    isDeleteButtonLoading?: boolean;
    seoTestKey?: string;
    onCheck: (urlGuid: string) => void;
    onDelete?: (urlGuid: string) => void;
    showClusterLabel?: boolean;
};

export default function ServiceableUrlsTable({
    serviceableUrls,
    urlClusters,
    isLoading,
    isCheckButtonLoading,
    isDeleteButtonLoading,
    seoTestKey,
    onDelete,
    onCheck,
    showClusterLabel,
}: Props) {
    return (
        <Table
            className="serviceable-urls-table"
            pagination={false}
            size="small"
            dataSource={getServiceableUrlsTableData(serviceableUrls, urlClusters)}
            loading={isLoading}
            scroll={{ x: true }}
        >
            <Column
                key="idx"
                title="#"
                className="number-column"
                render={(text, record: ServiceableUrlTableRecord, index) => record.idx}
            />

            <Column
                key="url"
                title="URL"
                className="url-column"
                render={(text, record: ServiceableUrlTableRecord, index) => (
                    <ServiceableUrlsLinkCell
                        urlGuid={record.key}
                        websiteGuid={record.websiteGuid}
                        url={record.url}
                        isAnalyzed={record.lastAnalyzed ? true : false}
                        seoTestKey={seoTestKey}
                        statusCode={record.statusCode}
                    />
                )}
            />

            {showClusterLabel && (
                <Column
                    key="clusterLabel"
                    dataIndex="clusterLabel"
                    title="Page Group"
                />
            )}
            <Column
                key="seoScore"
                title="SEO Score"
                className="al-left"
                width={110}
                render={(text, record: ServiceableUrlTableRecord, index) => <ServiceableUrlsSeoScoreCell seoScore={record.seoScore} />}
            />
            <Column
                key="checks"
                title="Checks"
                className="al-left no-wrap"
                width={260}
                render={(text, record: ServiceableUrlTableRecord, index) => <ServiceableUrlsChecksCell checks={record.checks} />}
            />
            <Column
                key="lastAnalyzed"
                title="Last analyzed"
                className="al-right no-wrap"
                width={130}
                render={(text, record: ServiceableUrlTableRecord, index) => <ServiceableUrlsLastAnalyzedCell lastAnalyzed={record.lastAnalyzed} />}
            />
            <Column
                key="action"
                className="al-right no-wrap"
                width={60}
                render={(text, record: ServiceableUrlTableRecord, index) => (
                    <ServiceableUrlsActionCell
                        isCheckButtonLoading={isCheckButtonLoading}
                        isDeleteButtonLoading={isDeleteButtonLoading}
                        onCheckUrlClick={() => onCheck(record.key)}
                        onDeleteUrlClick={onDelete ? () => onDelete(record.key) : undefined}
                    />
                )}
            />
        </Table>
    );
}